import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';

const CustomDialog = ({ open, onClose, onContinue }) => {
  const dialogStyles = {
    // minWidth: '600px',
    borderRadius: '1px',
    with:'600px'
  };

  const titleStyles = {
    backgroundColor: '#4169E1',
    color: '#fff',
    padding: '16px',
    borderRadius: '1px 1px 0 0',
    textAlign: 'center',
  };

  const contentStyles = {
    padding: '16px',
    textAlign: 'center',
  };

  const actionsStyles = {
    justifyContent: 'flex-end',
    padding: '16px',
  };

  return (
    <Dialog open={open} onClose={onClose} style={dialogStyles}>
      <DialogTitle style={titleStyles}>Aviso de Escala Incompatível com Padrões CLT</DialogTitle>
      <DialogContent style={contentStyles}>
        <DialogContentText>
          Desculpe, mas parece que a escala que você definiu não está em conformidade com os padrões estabelecidos pela Consolidação das Leis do Trabalho (CLT).<br/> A escala deve ser ajustada para garantir o cumprimento das leis trabalhistas vigentes.
        </DialogContentText>
        <DialogContentText>
          Deseja realmente continuar com a escala atual?
        </DialogContentText>
      </DialogContent>
      <DialogActions style={actionsStyles}>
        <Button onClick={onClose}>Ajustar Escala</Button>
        <Button onClick={onContinue} color="primary" autoFocus>
          Continuar com a Escala Atual
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CustomDialog;
